export default __webpack_public_path__ + "static/media/admin.a7674609.jpeg";